// FacebookPost i18n fragment
const fragment = {
  vi: {
    // ----- List screen (FacebookPost.js) -----
    'fbPost.facebookPost.statusAll': 'Tất cả trạng thái',
    'fbPost.facebookPost.statusDraft': 'Nháp',
    'fbPost.facebookPost.statusScheduled': 'Đã lên lịch',
    'fbPost.facebookPost.statusPublished': 'Đã đăng',
    'fbPost.facebookPost.statusFailed': 'Lỗi',
    'fbPost.facebookPost.tabAll': 'Tất cả',
    'fbPost.facebookPost.allAccounts': 'Tất cả tài khoản',
    'fbPost.facebookPost.title': 'Bài viết Facebook',
    'fbPost.facebookPost.createPost': 'Tạo bài viết',
    'fbPost.facebookPost.search': 'Tìm kiếm',
    'fbPost.facebookPost.searchPlaceholder': 'Tìm theo nội dung, tên Page',
    'fbPost.facebookPost.account': 'Tài khoản',
    'fbPost.facebookPost.status': 'Trạng thái',
    'fbPost.facebookPost.filter': 'Lọc',
    'fbPost.facebookPost.reset': 'Đặt lại',

    // ----- Form screen (FacebookPostForm.js) -----
    'fbPost.form.previewReelCaption': 'Caption cho Reel sẽ hiển thị ở đây...',
    'fbPost.form.previewMessage': 'Nội dung bài viết sẽ hiển thị ở đây...',
    'fbPost.form.badgePublished': '✓ Đã đăng',
    'fbPost.form.badgeFailed': '⚠ Lỗi',
    'fbPost.form.badgeScheduled': '📅 Đã lên lịch',
    'fbPost.form.badgeProcessing': '⏳ Đang đăng',
    'fbPost.form.badgeDraft': '• Nháp',

    'fbPost.form.errOnlyImages': 'Chỉ chấp nhận file ảnh.',
    'fbPost.form.errNonImageSkipped': '{count} file không phải ảnh đã bị bỏ qua.',
    'fbPost.form.errOversized': '{count} ảnh vượt quá {max}MB, đã bỏ qua: {names}',
    'fbPost.form.errMaxImages': 'Tối đa {max} ảnh mỗi bài viết.',
    'fbPost.form.errRemainingImages': 'Chỉ thêm được {remaining} ảnh nữa (tối đa {max}).',
    'fbPost.form.imagesUploaded': 'Đã tải lên {count} ảnh.',
    'fbPost.form.imageUploadFailed': 'Tải ảnh lên thất bại.',
    'fbPost.form.errOnlyVideo': 'Chỉ chấp nhận file video.',
    'fbPost.form.videoUploaded': 'Tải video lên thành công.',
    'fbPost.form.videoUploadFailed': 'Tải video lên thất bại.',

    'fbPost.form.errSelectAccount': 'Vui lòng chọn tài khoản Facebook.',
    'fbPost.form.errSelectPage': 'Vui lòng chọn Page muốn đăng.',
    'fbPost.form.errReelNeedsVideo': 'Reel bắt buộc phải có video.',
    'fbPost.form.errNeedContent': 'Bài viết cần có nội dung hoặc hình ảnh.',
    'fbPost.form.errSelectTime': 'Vui lòng chọn thời gian đăng.',
    'fbPost.form.errLeadTime': 'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',

    'fbPost.form.scheduleUpdated': 'Đã cập nhật lịch đăng.',
    'fbPost.form.changesSaved': 'Đã lưu thay đổi.',
    'fbPost.form.saveFailed': 'Lưu thất bại.',
    'fbPost.form.publishedSuccess': 'Đăng bài thành công!',
    'fbPost.form.sent': 'Đã gửi.',
    'fbPost.form.scheduledAt': 'Đã lên lịch đăng lúc {time}.',
    'fbPost.form.draftSaved': 'Đã lưu nháp.',
    'fbPost.form.createFailed': 'Tạo bài viết thất bại.',

    'fbPost.form.submitUpdateSchedule': 'Cập nhật lịch',
    'fbPost.form.submitSaveChanges': 'Lưu thay đổi',
    'fbPost.form.submitSchedule': '📅 Lên lịch đăng',
    'fbPost.form.submitPublishNow': '🚀 Đăng ngay',
    'fbPost.form.submitSaveDraft': 'Lưu nháp',

    'fbPost.form.titleEditReel': 'Sửa Reel',
    'fbPost.form.titleEditPost': 'Sửa bài viết',
    'fbPost.form.titleCreateReel': 'Tạo Reel cho Page',
    'fbPost.form.titleCreatePost': 'Tạo bài viết lên Page',
    'fbPost.form.subtitleReel':
      'Đăng video dọc (Reel) lên Page. Hỗ trợ upload file hoặc dán URL video.',
    'fbPost.form.subtitlePost':
      'Chọn tài khoản, Page và soạn nội dung. Bạn có thể lưu nháp, lên lịch hoặc đăng ngay.',

    'fbPost.form.step1Title': 'Đăng tới đâu?',
    'fbPost.form.step1Hint': 'Chọn tài khoản kết nối và Page nhận bài',
    'fbPost.form.accountLabel': 'Tài khoản Facebook',
    'fbPost.form.accountPlaceholder': 'Chọn tài khoản đã đăng nhập',
    'fbPost.form.noAccounts': 'Chưa có tài khoản nào',
    'fbPost.form.pageLabel': 'Page',
    'fbPost.form.pagePlaceholderPickAccount': 'Chọn tài khoản trước',
    'fbPost.form.pagePlaceholderLoading': 'Đang tải pages...',
    'fbPost.form.pagePlaceholderEmpty': 'Không có Page nào',
    'fbPost.form.pagePlaceholderPick': 'Chọn Page muốn đăng',
    'fbPost.form.noPagesManaged': 'Tài khoản này không quản trị Page nào',
    'fbPost.form.reloadPages': 'Đồng bộ lại danh sách Page',
    'fbPost.form.reloadPagesSuccess': 'Đã đồng bộ danh sách Page',
    'fbPost.form.reloadPagesFailed': 'Đồng bộ danh sách Page thất bại',
    'fbPost.form.noPagesWarnTitle': 'Tài khoản này chưa quản trị Page nào.',
    'fbPost.form.noPagesWarnDesc1':
      'Hãy kiểm tra rằng bạn là admin của Page và đã cấp đầy đủ quyền',
    'fbPost.form.noPagesWarnDesc2': 'khi đăng nhập.',

    'fbPost.form.step2Title': 'Loại bài viết',
    'fbPost.form.step2Hint': 'Bài viết bình thường (Feed) hoặc Reel (video dọc)',
    'fbPost.form.feedLabel': 'Bài viết Feed',
    'fbPost.form.feedHint': 'Văn bản + ảnh, hiển thị trên News Feed của Page.',
    'fbPost.form.reelLabel': 'Reel',
    'fbPost.form.reelHint': 'Video dọc 9:16 (3–90s, ≤1GB), hiển thị trên tab Reels.',
    'fbPost.form.cannotChangeType': 'Không thể đổi loại bài viết sau khi đã tạo.',

    'fbPost.form.step3TitleReel': 'Mô tả Reel',
    'fbPost.form.step3TitlePost': 'Soạn nội dung',
    'fbPost.form.step3HintReel': 'Caption sẽ hiển thị dưới Reel (tuỳ chọn)',
    'fbPost.form.step3HintPost': 'Đoạn văn bản sẽ hiển thị trên bài viết',
    'fbPost.form.messagePlaceholder': 'Bạn đang nghĩ gì?',

    'fbPost.form.step4TitleReel': 'Video Reel',
    'fbPost.form.step4TitlePost': 'Hình ảnh',
    'fbPost.form.step4HintReel': 'Bắt buộc — kéo thả file MP4 dọc 9:16 hoặc dán URL công khai',
    'fbPost.form.step4HintPost':
      'Tuỳ chọn — tối đa {max} ảnh, mỗi ảnh ≤ {sizeMb}MB. Ảnh lớn sẽ được tự động tối ưu.',

    'fbPost.form.dropVideo': 'Bấm hoặc kéo thả video Reel vào đây',
    'fbPost.form.videoHint': 'MP4/MOV, dọc 9:16, 3–90 giây, tối đa 1GB',
    'fbPost.form.or': 'HOẶC',
    'fbPost.form.videoUrlPlaceholder': 'Dán URL video công khai (https://...mp4)',
    'fbPost.form.removeVideo': 'Xoá video',
    'fbPost.form.changeVideo': 'Đổi video khác',
    'fbPost.form.fileLabel': 'File: {value}',
    'fbPost.form.urlLabel': 'URL: {value}',

    'fbPost.form.dropImages': 'Bấm hoặc kéo thả ảnh vào đây',
    'fbPost.form.imagesHint': 'JPG, PNG, WEBP — tối đa {max} ảnh, mỗi ảnh ≤ {sizeMb}MB',
    'fbPost.form.removeImage': 'Xoá ảnh',
    'fbPost.form.addImage': 'Thêm ảnh',
    'fbPost.form.imagesCount': '{count}/{max} ảnh — kéo thả hoặc bấm ô trống để thêm',

    'fbPost.form.step5Title': 'Chế độ đăng',
    'fbPost.form.step5Hint': 'Lưu nháp, lên lịch tự động hoặc đăng ngay lập tức',
    'fbPost.form.modeDraftLabel': 'Lưu nháp',
    'fbPost.form.modeDraftHint': 'Lưu bài để chỉnh sửa và đăng sau.',
    'fbPost.form.modeScheduleLabel': 'Lên lịch',
    'fbPost.form.modeScheduleHint': 'Tự động đăng vào ngày giờ chỉ định.',
    'fbPost.form.modePublishLabel': 'Đăng ngay',
    'fbPost.form.modePublishHint': 'Gửi bài lên Facebook ngay lập tức.',

    'fbPost.form.scheduleTime': 'Thời gian đăng',
    'fbPost.form.scheduleDatePlaceholder': 'Chọn ngày và giờ đăng',
    'fbPost.form.timezoneNote': 'Múi giờ:',
    'fbPost.form.leadNote': 'Tối thiểu cách hiện tại {minutes} phút.',
    'fbPost.form.willPostAt': '⏰ Sẽ đăng',

    'fbPost.form.preview': 'Xem trước',
    'fbPost.form.pageNamePlaceholder': 'Tên Page sẽ hiển thị ở đây',
    'fbPost.form.willPostShort': 'Sẽ đăng {time}',
    'fbPost.form.justNow': 'Vừa xong',
    'fbPost.form.reelPreviewPlaceholder': 'Video Reel sẽ hiển thị ở đây',
    'fbPost.form.like': '👍 Thích',
    'fbPost.form.comment': '💬 Bình luận',
    'fbPost.form.share': '↗ Chia sẻ',

    'fbPost.form.footerSchedule': 'Bài sẽ được hệ thống tự động đăng đúng thời điểm bạn chọn.',
    'fbPost.form.footerPublish': 'Bài sẽ được gửi lên Facebook ngay khi bạn nhấn nút.',
    'fbPost.form.footerDraft': 'Nháp có thể chỉnh sửa, lên lịch hoặc đăng bất cứ lúc nào.',
    'fbPost.form.cancel': 'Huỷ',

    // ----- Table (Table.js) -----
    'fbPost.table.statusPublished': 'Đã đăng',
    'fbPost.table.statusFailed': 'Lỗi',
    'fbPost.table.statusScheduled': '📅 Đã lên lịch',
    'fbPost.table.statusProcessing': '⏳ Đang đăng',
    'fbPost.table.statusDraft': 'Nháp',

    'fbPost.table.waitingCron': 'Đang chờ cron xử lý',
    'fbPost.table.processing': 'Đang đăng…',

    'fbPost.table.errSelectTime': 'Vui lòng chọn thời gian.',
    'fbPost.table.errLeadTime': 'Thời gian đăng phải cách hiện tại ít nhất {minutes} phút.',
    'fbPost.table.changeTime': 'Đổi giờ đăng',
    'fbPost.table.newDatePlaceholder': 'Chọn ngày giờ mới',
    'fbPost.table.leadNote': 'Cách hiện tại tối thiểu {minutes} phút.',
    'fbPost.table.cancel': 'Huỷ',
    'fbPost.table.saveSchedule': 'Lưu lịch',

    'fbPost.table.confirmDeleteTitle': 'Xoá bài viết?',
    'fbPost.table.confirmDeleteDesc':
      'Bài viết sẽ bị xoá khỏi hệ thống. Bài đã đăng trên Facebook vẫn còn.',
    'fbPost.table.confirmDeleteBtn': 'Xoá',
    'fbPost.table.postDeleted': 'Đã xoá bài viết.',

    'fbPost.table.confirmPublishTitle': 'Đăng ngay bài đã lên lịch?',
    'fbPost.table.confirmPublishDesc':
      'Lịch đăng tự động sẽ bị huỷ và bài sẽ được đăng ngay lập tức.',
    'fbPost.table.confirmPublishBtn': 'Đăng ngay',
    'fbPost.table.publishSuccess': 'Đăng bài thành công.',
    'fbPost.table.publishFailed': 'Đăng bài thất bại.',

    'fbPost.table.scheduleUpdated': 'Đã cập nhật lịch đăng.',
    'fbPost.table.scheduleUpdateFailed': 'Cập nhật lịch thất bại.',

    'fbPost.table.confirmCancelTitle': 'Huỷ lịch đăng?',
    'fbPost.table.confirmCancelDesc': 'Bài sẽ chuyển về trạng thái Nháp và không tự động đăng nữa.',
    'fbPost.table.confirmCancelBtn': 'Huỷ lịch',
    'fbPost.table.scheduleCancelled': 'Đã huỷ lịch đăng.',
    'fbPost.table.scheduleCancelFailed': 'Huỷ lịch thất bại.',

    'fbPost.table.colPage': 'Page',
    'fbPost.table.colContent': 'Nội dung',
    'fbPost.table.colStatus': 'Trạng thái',
    'fbPost.table.colTime': 'Thời gian',
    'fbPost.table.colLink': 'Link bài viết',
    'fbPost.table.colCreatedAt': 'Tạo lúc',
    'fbPost.table.colActions': 'Thao tác',

    'fbPost.table.copyLink': 'Sao chép link',
    'fbPost.table.viewOnFacebook': 'Xem trên Facebook',
    'fbPost.table.cancelSchedule': 'Huỷ lịch đăng',
    'fbPost.table.publishNow': 'Đăng ngay',
    'fbPost.table.editPost': 'Sửa bài viết',
    'fbPost.table.deletePost': 'Xoá bài viết',

    'fbPost.table.emptyTitle': 'Chưa có bài viết',
    'fbPost.table.emptyDesc': 'Tạo bài viết đầu tiên để đăng lên Page',
  },
  en: {
    // ----- List screen (FacebookPost.js) -----
    'fbPost.facebookPost.statusAll': 'All statuses',
    'fbPost.facebookPost.statusDraft': 'Draft',
    'fbPost.facebookPost.statusScheduled': 'Scheduled',
    'fbPost.facebookPost.statusPublished': 'Published',
    'fbPost.facebookPost.statusFailed': 'Failed',
    'fbPost.facebookPost.tabAll': 'All',
    'fbPost.facebookPost.allAccounts': 'All accounts',
    'fbPost.facebookPost.title': 'Facebook Posts',
    'fbPost.facebookPost.createPost': 'Create post',
    'fbPost.facebookPost.search': 'Search',
    'fbPost.facebookPost.searchPlaceholder': 'Search by content or Page name',
    'fbPost.facebookPost.account': 'Account',
    'fbPost.facebookPost.status': 'Status',
    'fbPost.facebookPost.filter': 'Filter',
    'fbPost.facebookPost.reset': 'Reset',

    // ----- Form screen (FacebookPostForm.js) -----
    'fbPost.form.previewReelCaption': 'Reel caption will appear here...',
    'fbPost.form.previewMessage': 'Post content will appear here...',
    'fbPost.form.badgePublished': '✓ Published',
    'fbPost.form.badgeFailed': '⚠ Failed',
    'fbPost.form.badgeScheduled': '📅 Scheduled',
    'fbPost.form.badgeProcessing': '⏳ Publishing',
    'fbPost.form.badgeDraft': '• Draft',

    'fbPost.form.errOnlyImages': 'Only image files are accepted.',
    'fbPost.form.errNonImageSkipped': '{count} non-image file(s) were skipped.',
    'fbPost.form.errOversized': '{count} image(s) exceed {max}MB and were skipped: {names}',
    'fbPost.form.errMaxImages': 'Maximum {max} images per post.',
    'fbPost.form.errRemainingImages': 'Only {remaining} more image(s) can be added (max {max}).',
    'fbPost.form.imagesUploaded': 'Uploaded {count} image(s).',
    'fbPost.form.imageUploadFailed': 'Image upload failed.',
    'fbPost.form.errOnlyVideo': 'Only video files are accepted.',
    'fbPost.form.videoUploaded': 'Video uploaded successfully.',
    'fbPost.form.videoUploadFailed': 'Video upload failed.',

    'fbPost.form.errSelectAccount': 'Please select a Facebook account.',
    'fbPost.form.errSelectPage': 'Please select a Page to post to.',
    'fbPost.form.errReelNeedsVideo': 'A Reel requires a video.',
    'fbPost.form.errNeedContent': 'The post needs content or an image.',
    'fbPost.form.errSelectTime': 'Please select a publish time.',
    'fbPost.form.errLeadTime': 'Publish time must be at least {minutes} minutes from now.',

    'fbPost.form.scheduleUpdated': 'Schedule updated.',
    'fbPost.form.changesSaved': 'Changes saved.',
    'fbPost.form.saveFailed': 'Save failed.',
    'fbPost.form.publishedSuccess': 'Post published successfully!',
    'fbPost.form.sent': 'Sent.',
    'fbPost.form.scheduledAt': 'Scheduled to publish at {time}.',
    'fbPost.form.draftSaved': 'Draft saved.',
    'fbPost.form.createFailed': 'Failed to create post.',

    'fbPost.form.submitUpdateSchedule': 'Update schedule',
    'fbPost.form.submitSaveChanges': 'Save changes',
    'fbPost.form.submitSchedule': '📅 Schedule',
    'fbPost.form.submitPublishNow': '🚀 Publish now',
    'fbPost.form.submitSaveDraft': 'Save draft',

    'fbPost.form.titleEditReel': 'Edit Reel',
    'fbPost.form.titleEditPost': 'Edit post',
    'fbPost.form.titleCreateReel': 'Create a Reel for the Page',
    'fbPost.form.titleCreatePost': 'Create a Page post',
    'fbPost.form.subtitleReel':
      'Publish a vertical video (Reel) to the Page. Upload a file or paste a video URL.',
    'fbPost.form.subtitlePost':
      'Choose an account and Page, then write your content. You can save a draft, schedule, or publish now.',

    'fbPost.form.step1Title': 'Where to post?',
    'fbPost.form.step1Hint': 'Choose the connected account and the receiving Page',
    'fbPost.form.accountLabel': 'Facebook account',
    'fbPost.form.accountPlaceholder': 'Select a signed-in account',
    'fbPost.form.noAccounts': 'No accounts yet',
    'fbPost.form.pageLabel': 'Page',
    'fbPost.form.pagePlaceholderPickAccount': 'Select an account first',
    'fbPost.form.pagePlaceholderLoading': 'Loading pages...',
    'fbPost.form.pagePlaceholderEmpty': 'No Pages available',
    'fbPost.form.pagePlaceholderPick': 'Select a Page to post to',
    'fbPost.form.noPagesManaged': 'This account does not manage any Page',
    'fbPost.form.reloadPages': 'Re-sync Page list',
    'fbPost.form.reloadPagesSuccess': 'Page list synced',
    'fbPost.form.reloadPagesFailed': 'Failed to sync Page list',
    'fbPost.form.noPagesWarnTitle': 'This account does not manage any Page yet.',
    'fbPost.form.noPagesWarnDesc1':
      'Make sure you are an admin of the Page and granted full permissions',
    'fbPost.form.noPagesWarnDesc2': 'when signing in.',

    'fbPost.form.step2Title': 'Post type',
    'fbPost.form.step2Hint': 'Regular post (Feed) or Reel (vertical video)',
    'fbPost.form.feedLabel': 'Feed post',
    'fbPost.form.feedHint': 'Text + images, shown on the Page News Feed.',
    'fbPost.form.reelLabel': 'Reel',
    'fbPost.form.reelHint': 'Vertical 9:16 video (3–90s, ≤1GB), shown on the Reels tab.',
    'fbPost.form.cannotChangeType': 'Post type cannot be changed after creation.',

    'fbPost.form.step3TitleReel': 'Reel description',
    'fbPost.form.step3TitlePost': 'Write content',
    'fbPost.form.step3HintReel': 'Caption shown below the Reel (optional)',
    'fbPost.form.step3HintPost': 'Text shown on the post',
    'fbPost.form.messagePlaceholder': "What's on your mind?",

    'fbPost.form.step4TitleReel': 'Reel video',
    'fbPost.form.step4TitlePost': 'Images',
    'fbPost.form.step4HintReel': 'Required — drag & drop a vertical 9:16 MP4 or paste a public URL',
    'fbPost.form.step4HintPost':
      'Optional — up to {max} images, each ≤ {sizeMb}MB. Large images are optimized automatically.',

    'fbPost.form.dropVideo': 'Click or drag & drop a Reel video here',
    'fbPost.form.videoHint': 'MP4/MOV, vertical 9:16, 3–90 seconds, up to 1GB',
    'fbPost.form.or': 'OR',
    'fbPost.form.videoUrlPlaceholder': 'Paste a public video URL (https://...mp4)',
    'fbPost.form.removeVideo': 'Remove video',
    'fbPost.form.changeVideo': 'Change video',
    'fbPost.form.fileLabel': 'File: {value}',
    'fbPost.form.urlLabel': 'URL: {value}',

    'fbPost.form.dropImages': 'Click or drag & drop images here',
    'fbPost.form.imagesHint': 'JPG, PNG, WEBP — up to {max} images, each ≤ {sizeMb}MB',
    'fbPost.form.removeImage': 'Remove image',
    'fbPost.form.addImage': 'Add image',
    'fbPost.form.imagesCount': '{count}/{max} images — drag & drop or click an empty cell to add',

    'fbPost.form.step5Title': 'Publish mode',
    'fbPost.form.step5Hint': 'Save a draft, auto-schedule, or publish immediately',
    'fbPost.form.modeDraftLabel': 'Save draft',
    'fbPost.form.modeDraftHint': 'Save the post to edit and publish later.',
    'fbPost.form.modeScheduleLabel': 'Schedule',
    'fbPost.form.modeScheduleHint': 'Auto-publish at the specified date and time.',
    'fbPost.form.modePublishLabel': 'Publish now',
    'fbPost.form.modePublishHint': 'Send the post to Facebook immediately.',

    'fbPost.form.scheduleTime': 'Publish time',
    'fbPost.form.scheduleDatePlaceholder': 'Select publish date and time',
    'fbPost.form.timezoneNote': 'Timezone:',
    'fbPost.form.leadNote': 'At least {minutes} minutes from now.',
    'fbPost.form.willPostAt': '⏰ Will publish',

    'fbPost.form.preview': 'Preview',
    'fbPost.form.pageNamePlaceholder': 'Page name will appear here',
    'fbPost.form.willPostShort': 'Publishing {time}',
    'fbPost.form.justNow': 'Just now',
    'fbPost.form.reelPreviewPlaceholder': 'Reel video will appear here',
    'fbPost.form.like': '👍 Like',
    'fbPost.form.comment': '💬 Comment',
    'fbPost.form.share': '↗ Share',

    'fbPost.form.footerSchedule':
      'The post will be auto-published by the system at the time you chose.',
    'fbPost.form.footerPublish':
      'The post will be sent to Facebook as soon as you click the button.',
    'fbPost.form.footerDraft': 'A draft can be edited, scheduled, or published anytime.',
    'fbPost.form.cancel': 'Cancel',

    // ----- Table (Table.js) -----
    'fbPost.table.statusPublished': 'Published',
    'fbPost.table.statusFailed': 'Failed',
    'fbPost.table.statusScheduled': '📅 Scheduled',
    'fbPost.table.statusProcessing': '⏳ Publishing',
    'fbPost.table.statusDraft': 'Draft',

    'fbPost.table.waitingCron': 'Waiting for cron to process',
    'fbPost.table.processing': 'Publishing…',

    'fbPost.table.errSelectTime': 'Please select a time.',
    'fbPost.table.errLeadTime': 'Publish time must be at least {minutes} minutes from now.',
    'fbPost.table.changeTime': 'Change publish time',
    'fbPost.table.newDatePlaceholder': 'Select a new date and time',
    'fbPost.table.leadNote': 'At least {minutes} minutes from now.',
    'fbPost.table.cancel': 'Cancel',
    'fbPost.table.saveSchedule': 'Save schedule',

    'fbPost.table.confirmDeleteTitle': 'Delete post?',
    'fbPost.table.confirmDeleteDesc':
      'The post will be removed from the system. Posts already published on Facebook remain.',
    'fbPost.table.confirmDeleteBtn': 'Delete',
    'fbPost.table.postDeleted': 'Post deleted.',

    'fbPost.table.confirmPublishTitle': 'Publish the scheduled post now?',
    'fbPost.table.confirmPublishDesc':
      'The auto-schedule will be cancelled and the post will be published immediately.',
    'fbPost.table.confirmPublishBtn': 'Publish now',
    'fbPost.table.publishSuccess': 'Post published successfully.',
    'fbPost.table.publishFailed': 'Failed to publish post.',

    'fbPost.table.scheduleUpdated': 'Schedule updated.',
    'fbPost.table.scheduleUpdateFailed': 'Failed to update schedule.',

    'fbPost.table.confirmCancelTitle': 'Cancel schedule?',
    'fbPost.table.confirmCancelDesc':
      'The post will return to Draft and will no longer auto-publish.',
    'fbPost.table.confirmCancelBtn': 'Cancel schedule',
    'fbPost.table.scheduleCancelled': 'Schedule cancelled.',
    'fbPost.table.scheduleCancelFailed': 'Failed to cancel schedule.',

    'fbPost.table.colPage': 'Page',
    'fbPost.table.colContent': 'Content',
    'fbPost.table.colStatus': 'Status',
    'fbPost.table.colTime': 'Time',
    'fbPost.table.colLink': 'Post link',
    'fbPost.table.colCreatedAt': 'Created at',
    'fbPost.table.colActions': 'Actions',

    'fbPost.table.copyLink': 'Copy link',
    'fbPost.table.viewOnFacebook': 'View on Facebook',
    'fbPost.table.cancelSchedule': 'Cancel schedule',
    'fbPost.table.publishNow': 'Publish now',
    'fbPost.table.editPost': 'Edit post',
    'fbPost.table.deletePost': 'Delete post',

    'fbPost.table.emptyTitle': 'No posts yet',
    'fbPost.table.emptyDesc': 'Create your first post to publish to a Page',
  },
};

export default fragment;
